import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import Collections from 'views/admin/collections';
import Profile from 'views/admin/profile';
import Pricing from 'views/admin/pricing';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import SignUpView from 'views/auth/signUp';
import VerifyView from 'views/auth/verify';
import ForgotPasswordView from 'views/auth/forgotPassword';
import ResetPasswordConfirmView from 'views/auth/resetPassword';

const routes = [
  {
    name: 'Main Dashboard',
    layout: '/',
    path: '/dashboard',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
    name: 'Collections',
    layout: '/',
    path: '/collections',
    icon: (
      <Icon
        as={MdOutlineShoppingCart}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <Collections />,
    secondary: true,
  },
  {
    name: 'Pricing',
    layout: '/',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    path: '/pricing',
    component: <Pricing />,
  },
  {
    name: 'Profile',
    layout: '/',
    path: '/profile',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Profile />,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
  },
  {
    name: 'Sign Up',
    layout: '/auth',
    path: '/sign-up',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignUpView />,
  },
  {
    name: 'Verify Email',
    layout: '/auth',
    path: '/verify',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <VerifyView />,
  },
    {
    name: 'Forgot Password',
    layout: '/auth',
    path: '/forgot-password',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <ForgotPasswordView />,
  },
  {
    name: 'Reset Password',
    layout: '/auth',
    path: '/reset-password/:token',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <ResetPasswordConfirmView />,
  }
];

export default routes;
